import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GithubCommitIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GithubCommit",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.57 14.42h-5.85c-.71-3.06-3.46-5.35-6.74-5.35s-6.03 2.28-6.74 5.35H3.43c-.8 0-1.43.64-1.43 1.43s.64 1.44 1.43 1.44h5.75c.6 3.21 3.42 5.64 6.8 5.64s6.2-2.43 6.8-5.64h5.78c.8 0 1.43-.64 1.43-1.44s-.64-1.43-1.43-1.43Zm-12.58 5.64c-2.24 0-4.07-1.82-4.07-4.07s1.82-4.07 4.07-4.07 4.07 1.82 4.07 4.07-1.82 4.07-4.07 4.07"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.86 23.86c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-13.72c-3.15 0-5.71 2.56-5.71 5.71s2.56 5.71 5.71 5.71 5.71-2.56 5.71-5.71-2.56-5.71-5.71-5.71"
      }), /*#__PURE__*/_jsx("path", {
        d: "M30.71 17h-8a1.14 1.14 0 1 1 0-2.28h8a1.14 1.14 0 1 1 0 2.28M9 17H1a1.14 1.14 0 1 1 0-2.28h8A1.14 1.14 0 1 1 9 17"
      })]
    })
  }));
};
GithubCommitIcon.displayName = 'GithubCommitIcon';